import React from "react";
import { usePageSeo } from "../../shared/seo";

const TermsAndConditions = () => {
  usePageSeo("termsAndConditions");

  return (
    <section className="section py-40 py-sm-60">
      <div className="container container-lg">
        <div className="text-center mb-32 mb-sm-40">
          <h2 className="fw-bold text-main-700 mb-8">Terms & Conditions</h2>
          <p className="text-neutral-600 mb-0">Last Updated: August 2026</p>
        </div>

        <div className="mx-auto" style={{ maxWidth: "860px" }}>
          <div className="rounded-12 bg-white border border-main-100 p-24 p-sm-32" style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.05)" }}>
            <p className="text-neutral-700 mb-16">
              These Terms & Conditions ("Terms") govern your use of the
              Fugu's website and the purchase of products through it. By
              accessing our website or placing an order, you agree to be bound
              by these Terms.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">1. Eligibility</h5>
            <p className="text-neutral-700 mb-16">
              You must be at least 18 years of age to place an order on our
              website. By placing an order, you confirm that the information
              you provide is accurate and complete.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">2. Products and Availability</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Product images shown on the website are for representation
                purposes and may differ slightly from the actual product.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Availability of products, including sizes, weights, and
                quantities, may vary based on stock and season.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                We reserve the right to limit quantities, refuse, or cancel
                orders for any reason.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">3. Pricing and Payment</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                All prices are listed in Indian Rupees (INR) and inclusive of
                applicable taxes unless stated otherwise.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Delivery charges and cash-on-delivery fees, where applicable,
                are shown at checkout.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                We accept payment through the methods displayed at checkout.
                Payment must be received before the order is processed.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">4. Orders and Delivery</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                An order is confirmed once you receive a confirmation message
                from us.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Delivery slots and areas are subject to availability. We
                strive to deliver within the chosen slot but do not guarantee
                exact delivery times.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Please inspect your order upon delivery and report any
                discrepancies within 24 hours.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">5. Cancellations and Refunds</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                You may cancel an order before it is processed for delivery.
                Once dispatched, cancellation may not be possible.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                If a product is damaged, of poor quality, or incorrect, we
                will arrange a replacement or refund as applicable under our
                return policy.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                Refunds are processed to the original payment method within a
                reasonable timeframe.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">6. User Accounts</h5>
            <ul className="mb-16 ps-4 text-neutral-700" style={{ listStyle: "none" }}>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                You are responsible for maintaining the confidentiality of
                your account credentials.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                You agree not to misuse the website or use it for any unlawful
                purpose.
              </li>
              <li className="mb-8">
                <span className="text-main-600 me-8">•</span>
                We may suspend or terminate accounts that violate these Terms.
              </li>
            </ul>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">7. Intellectual Property</h5>
            <p className="text-neutral-700 mb-16">
              All content on this website, including text, graphics, logos,
              images, and software, is the property of Fugu's and is protected
              by applicable intellectual property laws. You may not reproduce,
              distribute, or use any content without our prior written consent.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">8. Limitation of Liability</h5>
            <p className="text-neutral-700 mb-16">
              To the maximum extent permitted by law, Fugu's shall not be
              liable for any indirect, incidental, special, or consequential
              damages arising out of your use of our website or products.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">9. Governing Law</h5>
            <p className="text-neutral-700 mb-16">
              These Terms are governed by and construed in accordance with the
              laws of India. Any disputes arising from these Terms shall be
              subject to the exclusive jurisdiction of the courts of Ernakulam,
              Kerala.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">10. Changes to These Terms</h5>
            <p className="text-neutral-700 mb-16">
              We may update these Terms from time to time. Changes will be
              posted on this page, and your continued use of the website after
              such changes constitutes acceptance of the revised Terms.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">11. Contact Us</h5>
            <p className="text-neutral-700 mb-0">
              For any questions regarding these Terms, please contact us at{" "}
              <a href="mailto:info@fishhub.com" className="text-main-600 text-decoration-none">
                info@fishhub.com
              </a>{" "}
              or write to us at Ground Floor, Ward No. 16, Door No 446B, 446 C,
              FUGUS BUILDING, Elbo Road, Puthuvype, Ernakulam, Kerala - 682508.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
